"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._typecheckWMTSCapabilitiesLoader = exports.WMTSCapabilitiesLoader = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _parseWmts = require("../lib/wmts/parse-wmts");

var VERSION = typeof "3.3.2" !== 'undefined' ? "3.3.2" : 'latest';
var WMTSCapabilitiesLoader = {
  id: 'wmts-capabilities',
  name: 'WMTS Capabilities',
  module: 'wms',
  version: VERSION,
  worker: false,
  extensions: ['xml'],
  mimeTypes: ['application/vnd.ogc.wmts_xml', 'application/xml', 'text/xml'],
  testText: testXMLFile,
  options: {
    wms: {}
  },
  parse: function () {
    var _parse = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(arrayBuffer, options) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _parseWmts.parseWMTSCapabilities)(new TextDecoder().decode(arrayBuffer), options));
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    function parse(_x, _x2) {
      return _parse.apply(this, arguments);
    }
    return parse;
  }(),
  parseTextSync: function parseTextSync(text, options) {
    return (0, _parseWmts.parseWMTSCapabilities)(text, options);
  }
};
exports.WMTSCapabilitiesLoader = WMTSCapabilitiesLoader;
function testXMLFile(text) {
  return text.startsWith('<?xml');
}
var _typecheckWMTSCapabilitiesLoader = WMTSCapabilitiesLoader;
exports._typecheckWMTSCapabilitiesLoader = _typecheckWMTSCapabilitiesLoader;
//# sourceMappingURL=wmts-capabilities-loader.js.map